// Angular
import { Component, OnInit } from "@angular/core";
// Services
import { ElasticService } from "../../services/elastic";
// External
import * as lodash from "lodash";
import { ApiService } from "../../services/api";
import { FormsService } from "./../../services/forms";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ElementRef, NgZone, ViewChild } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";

import { MapsAPILoader } from "@agm/core";
@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
})
export class CompanyComponent implements OnInit {
  public query: string;
  public isPro: number = 1;
  private typingDelay: any;
  public currentPage: number;
  public maxPage: number;
  public form: FormGroup;
  public isEmailExist = false;
  public users: Array<any>;
  public imageLoader: boolean = true;
  public pageSize: number;
  public insights: Array<any>;
  public isInsightSelect = false;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public address: string;

  @ViewChild("search")
  public searchElementRef: ElementRef;
  public ifQueryHasSpaces: boolean = false;
  constructor(
    private elasticService: ElasticService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    public formsService: FormsService,
    private fireAuth: AngularFireAuth,

    private apiService: ApiService
  ) {
    this.currentPage = 0;
    this.pageSize = 30;
    this.query = "";
    this.form = new FormGroup({
      name: new FormControl("", Validators.required),
      email: new FormControl("", Validators.email),
      username: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      password: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirm: new FormControl("", Validators.required),
      address: new FormControl("", Validators.required),
      state: new FormControl("", Validators.required),
      country: new FormControl("", Validators.required),
      postCode: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
    });
    this.form.controls["username"].valueChanges.subscribe((value) => {
      var status = /^\S*$/.test(value);
      if (status) {
        this.username(value);
      } else {
        this.form.controls["username"].patchValue(String(value).trim());
      }
    });

    this.form.controls["password"].valueChanges.subscribe(() => {
      this.confirm();
    });

    this.form.controls["confirm"].valueChanges.subscribe(() => {
      this.confirm();
    });
    this.form.controls["email"].valueChanges.subscribe((value) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(value).toLowerCase())) {
        this.checkEmail(value);
      }
    });
    this.apiService.list("master/company-insights").then((res) => {
      this.insights = [];
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          let element = res[i];

          element.isSelected = false;
          if (element.status == 1) this.insights.push(element);
        }
      }
    });
  }

  ngOnInit() {
    this.goToPage(this.currentPage);
    this.zoom = 4;

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          const results = place.address_components;

          this.form.patchValue({ address: place.formatted_address });

          this.form.controls["postCode"].patchValue(
            this.findResult(results, "postal_code")
          );
          this.form.controls["state"].patchValue(
            this.findResult(results, "administrative_area_level_1")
          );
          this.form.controls["country"].patchValue(
            this.findResult(results, "country")
          );

          this.form.controls["city"].patchValue(
            this.findResult(results, "administrative_area_level_2")
          );
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }
  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  checkQueryHasSpaces(query) {
    return query.indexOf(' ') >= 0;
  }

 goToPage(index: number) {
    const fromIndex = index * this.pageSize;
    var queryParams = {};
    let newQuery = this.query.trim().toLocaleLowerCase();
    console.log("new Querry: ", newQuery)
    this.ifQueryHasSpaces = this.checkQueryHasSpaces(newQuery);
    if(newQuery == "" || newQuery == undefined || newQuery == null || !this.ifQueryHasSpaces)
    { console.log("iff")
      queryParams = {
        index: "users",
        type: "company",
        size: this.pageSize,
        from: fromIndex,
        "body/query/bool/must/query_string/query": `${newQuery}*`,
        "body/query/bool/must/query_string/fields": [`name`],
        "body/sort/registerDate/order": `desc`,
      };
    }
    else{
      console.log("elseee")
      queryParams = {
        index: "users",
        type: "company",
        size: this.pageSize,
        from: fromIndex,
        "body/query/bool/must/match_phrase_prefix/name": `${newQuery}*`,
        "body/sort/registerDate/order": `desc`,
      };
    
    }

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        // console.log(result);

        lodash.forEach(result["hits"], (item) => {
          // console.log(item)
          let com = item["_source"];
          com.status = com.status == undefined ? 1 : com.status;
          this.users.push(lodash.assign({ id: item["_id"] }, com));
        });

        window.scrollTo(0, 0);
        this.imageLoader = false;
        this.currentPage = index;
        this.maxPage = Math.ceil(result["total"] / this.pageSize);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(this.currentPage);
    }, 400);
  }
  async unVerfied(item) {
    if (confirm("Are you sure,you want to unverify the Company?")) {
      if (item.isVerified) {
        await this.apiService.set(`/users/${item.id}/isVerified`, false);
        await this.apiService.set(
          `/user-profiles/${item.uid}/${item.id}/isVerified`,
          false
        );
        item.isVerified = false;
      }
    }
  }
  async verified(item) {
    if (confirm("Are you sure,you want to Verify the Company?")) {
      if (!item.isVerified) {
        try {
          await this.apiService.set(`/users/${item.id}/isVerified`, true);
          await this.apiService.set(`/user-profiles/${item.uid}/${item.id}`, {
            type: 5,
            role: 1,
            isVerified: true,
          });
          this.apiService.set(
            `server-process/active-deactive-stats/${item.id}/2`,
            true
          );
          item.isVerified = true;
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  async activate(item) {
    if (confirm("Are you sure,you want to activate the Company?")) {
      try {
        await this.apiService.set(`/users/${item.id}/status`, 1);
        await this.apiService.set(
          `/user-profiles/${item.uid}/${item.id}/status`,
          1
        );
        this.apiService.set(
          `server-process/active-deactive-stats/${item.id}/1`,
          true
        );
        item.status = 1;
      } catch (error) {
        console.log(error);
      }
    }
  }

  async deactivate(item) {
    if (confirm("Are you sure,you want to deactivate the Company?")) {
      await this.apiService.set(`/users/${item.id}/status`, 2);
      await this.apiService.set(
        `/user-profiles/${item.uid}/${item.id}/status`,
        2
      );
      this.apiService.set(
        `server-process/active-deactive-stats/${item.id}/2`,
        true
      );
      item.status = 2;
    }
  }
  checkEmail(value) {
    this.fireAuth.auth.fetchProvidersForEmail(value).then((result) => {
      console.log("email", result);
      if (result.length) {
        this.isEmailExist = true;
      } else {
        this.isEmailExist = false;
      }
    });
  }
  username(value: string) {
    if (!value) {
      const errors = this.form.controls["username"].errors;
      if (errors) {
        delete errors.used;
        this.form.controls["username"].setErrors(errors);
      }
      return;
    }

    this.apiService
      .list("/index/users", {
        query: {
          orderByValue: true,
          equalTo: this.form.controls["username"].value.toLowerCase(),
        },
      })
      .then(
        (result) => {
          if (result.length) {
            this.form.controls["username"].setErrors({ used: true });
          } else {
            const errors = this.form.controls["username"].errors;
            if (errors) {
              delete errors.used;
              this.form.controls["username"].setErrors(errors);
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  confirm() {
    const password = this.form.controls["password"].value;
    const confirm = this.form.controls["confirm"].value;

    if (password !== confirm) {
      this.form.controls["confirm"].setErrors({ confirm: true });
    } else {
      this.form.controls["confirm"].setErrors(null);
    }
  }
  submit() {
    this.imageLoader = true;
    var insightObj = {};
    let count = 0;
    for (let i = 0; i < this.insights.length; i++) {
      const element = this.insights[i];

      if (element.isSelected) {
        insightObj[element.$key] = 1;
        ++count;
      }
    }

    if (count == 0) {
      this.isInsightSelect = true;
    } else {
      this.isInsightSelect = false;
    }

    if (this.isInsightSelect) return;
    let obj = {
      registerDate: parseInt(new Date().getTime() / 1000 + ""),
      email: this.form.value.email,
      username: this.form.value.username.toLowerCase(),
      name: this.form.value.name,
      type: 5,
      status: 2,
      password: this.form.value.password,
      phone: this.form.value.phone + "",
      updatedAt: new Date().getTime() / 1000,
      insights: insightObj,
      city: this.form.value.city,
      state: this.form.value.state,
      country: this.form.value.country,
      address: this.form.value.address,
      role: 1,
      location: {
        lat: this.latitude,
        lon: this.longitude,
      },
      isVerified: false,
    };
    this.apiService
      .set(
        `/server-process/create-user/${parseInt(
          new Date().getTime() / 1000 + ""
        )}`,
        obj
      )
      .then(() => {
        location.reload();
      })

      .catch((error) => {
        console.error(error);
        alert(error.message);
      });
  }
}
